import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLanguage } from '../../../context/LanguageContext';
import './Videos.css';

const Videos: React.FC = () => {
  const { t } = useLanguage();
  
  const handleVideoClick = (youtubeId: string) => {
    window.open(`https://www.youtube.com/watch?v=${youtubeId}`, '_blank');
  };

  const videos = [
    {
      id: 'video1',
      title: t('videos.video1.title'),
      duration: '3:15',
      youtubeId: 'hYOJijRUynw',
      thumbnail: `https://img.youtube.com/vi/hYOJijRUynw/maxresdefault.jpg`
    },
    {
      id: 'video2',
      title: t('videos.video2.title'),
      duration: '4:20',
      youtubeId: 'YKV7dVev8_4',
      thumbnail: `https://img.youtube.com/vi/YKV7dVev8_4/maxresdefault.jpg`
    }
  ];

  return (
    <section id="videos" className="videos-section py-5">
      <Container>
        <div className="text-center mb-5">
          <div className="luxury-title-container">
            <h2 className="luxury-section-title">{t('videos.title')}</h2>
            <div className="luxury-underline"></div>
          </div>
          <p className="luxury-subtitle">
            {t('videos.subtitle')}
          </p>
        </div>

        <Row>
          {videos.map((video) => (
            <Col lg={6} md={6} className="mb-4" key={video.id}>
              <div className="videos-container">
                <div className="video-card"
                  onClick={() => handleVideoClick(video.youtubeId)}
                >
                  <div className="video-thumbnail">
                    <img 
                      src={video.thumbnail} 
                      alt={video.title}
                      className="img-fluid"
                    />
                    <div className="video-overlay">
                      <div className="play-button">
                        <i className="fas fa-play"></i>
                      </div>
                      <div className="video-duration">{video.duration}</div>
                    </div>
                  </div>
                  <div className="video-info">
                    <h4 className="video-title">{video.title}</h4>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
        
        <Row>
          <Col className="text-center mt-4">
            <div className="videos-footer">
              <button 
                className="btn btn-outline-light"
                onClick={() => window.open('https://www.youtube.com/@Draysesezim', '_blank')}
              >
                <i className="fab fa-youtube me-2"></i>
                {t('videos.watchAll')}
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Videos;
